import _ from 'lodash';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import {
    Box, FormControlLabel, Radio, RadioGroup, TextField,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Button from '../../components/Button/CustomButton';
import CleanableInput from '../../components/Input/CleanableInput';
import FormDialog from '../../components/Dialog/FormDialog';
import GridContainer from '../../components/Grid/GridContainer';
import GridItem from '../../components/Grid/GridItem';
import ProgessDialog from '../../components/Dialog/ProgessDialog';
import ReactPlayer from '../../components/ReactPlayer/ReactPlayer';
import Snackbar from '../../components/Snackbar/Snackbar';
import Typography from '../../components/Typography/CustomTypography';
import UploadButton from '../../components/Button/UploadButton';
import {
    APIErrors,
    MEDIA_TYPE,
    SERVER_CHAR_LIMIT,
    BUSINESS_CONTACT,
    BUSINESS_CONTACT_VIEW,
    OUTSIDE_LINK,
    DISPLAY_BUSINESS_CARD,
    BOOTH_TYPE,
} from '../../common/Constants';
import Validation from '../../common/Validation';
import { whiteColor } from '../../assets/jss/global';
import styles from '../../assets/jss/pages/productRegisterPageStyle';
import PRODUCT_DIALOG_MODE from '../ProductManagement/Consts';
import Loader from '../../components/Loader/Loader';
import { UploadIcon } from '../../components/Icons/Icon';
import CommonFunctions from '../../common/Functions';
import BusinessCard from '../../components/BusinessCard';
import InputHasUnit from '../SeminarManagementOrganizer/inputHasUnit';
import CustomTextSelector from '../../selectors/CustomText';
import API from '../../common/API';

const useStyles = makeStyles(styles);

const defaultBusinessCardParams = {
    department: '',
    position: '',
    first_name: '',
    last_name: '',
    zip_code: '',
    address: '',
    phone_number: '',
    fax_number: '',
    email_public: '',
    email_notifications: '',
};
const MAX_CHAR_LENGTH = 255;
const MAX_ADDRESS_CHAR_LENGTH = 1000;

const ProductRegister = (props) => {
    const {
        companyID, productID, productData, errorCreate, successCreate, errorUpdate, successUpdate, getProduct,
        getProductClear, updateProduct, updateProductClear, createProduct, createProductClear, mode, closeDialogFunction,
        progessCreate, loadingCreate, onClickChangeToEditDialog, isLoading, token,
        isOpenProductDialog, handleCloseProductDialog, dialogTitle, eventInfo, settingsDisplayInfo,
        userInfo,
    } = props;
    const intl = useIntl();
    const classes = useStyles();

    const [dialog, setDialog] = useState({ isOpen: false, message: '' });
    const [validateResults, setValidateResults] = useState({});
    const [mediaType, setMediaType] = useState(MEDIA_TYPE.IMAGE);
    const [error, setError] = useState('');
    const [nameFile, setNameFile] = useState('');
    const [contactExtraValue, setContactExtraValue] = useState('');
    const [outsideLinkValue, setOutsideLinkValue] = useState('');
    const [displayBusinessCard, setDisplayBusinessCard] = useState('0');
    const [price, setPrice] = useState('');
    const [checkPrice, setCheckPrice] = useState(false);
    const [totalProduct, setTotalProduct] = useState('');
    const [checkTotalProduct, setCheckTotalProduct] = useState(false);

    const [businessCardParams, setBusinessCardParams] = useState(defaultBusinessCardParams);
    const customText = useSelector(CustomTextSelector.createGetCustomText());

    const submitData = useRef({
        documentRequestReception: '',
    });
    const formRef = useRef(null);

    const isSuccess = mode === PRODUCT_DIALOG_MODE.UPDATE ? successUpdate : successCreate;
    const errors = mode === PRODUCT_DIALOG_MODE.UPDATE ? errorUpdate : errorCreate;

    useEffect(() => {
        const defaultBusinessCardInfo = {
            ...businessCardParams,
            department: userInfo.department,
            position: userInfo.position,
            first_name: userInfo.first_name,
            last_name: userInfo.last_name,
            zip_code: userInfo.zip_code,
            address: userInfo.address,
            phone_number: userInfo.phone_number,
            fax_number: userInfo.fax_number,
            email_public: userInfo.email,
        };

        if (isOpenProductDialog && mode === PRODUCT_DIALOG_MODE.CREATE) {
            setBusinessCardParams({ ...defaultBusinessCardInfo });
        }

        if (isOpenProductDialog && (mode === PRODUCT_DIALOG_MODE.READ || mode === PRODUCT_DIALOG_MODE.UPDATE)) {
            if (productData.businessCard) {
                setDisplayBusinessCard('1');
            } else {
                setDisplayBusinessCard('0');
            }

            if (!_.isEmpty(productData.businessCardInfo?.email_public)) {
                setBusinessCardParams({
                    ...businessCardParams,
                    department: productData.businessCardInfo.department,
                    position: productData.businessCardInfo.position,
                    first_name: productData.businessCardInfo.first_name,
                    last_name: productData.businessCardInfo.last_name,
                    zip_code: productData.businessCardInfo.zip_code,
                    address: productData.businessCardInfo.address,
                    phone_number: productData.businessCardInfo.phone_number,
                    fax_number: productData.businessCardInfo.fax_number,
                    email_public: productData.businessCardInfo.email_public,
                    email_notifications: productData.businessCardInfo.email_notifications,
                });
            } else {
                setBusinessCardParams({ ...defaultBusinessCardInfo });
            }
        }
        if (isOpenProductDialog && mode === PRODUCT_DIALOG_MODE.UPDATE && productData.isWaitingOrder) {
            setDialog({
                isOpen: true,
                message: 'この商品が購入されていますが、承認されていません。名前、価格を変更したり、商品を削除したりする場合、この商品を含む注文が承認されなくなります。',
                severity: 'error',
            });
        }
    }, [mode, isOpenProductDialog, productData]);

    const handleSetBusinessCardParams = (field, value) => {
        setBusinessCardParams((params) => ({ ...params, [field]: value }));
    };

    // Get product information
    useEffect(() => {
        if (isOpenProductDialog && companyID && productID) getProduct(companyID, productID);
        return () => { getProductClear(); };
    }, [isOpenProductDialog, productID, companyID, getProduct, getProductClear]);

    // Deep clone event information to be updated and submitted
    useEffect(() => {
        if (productData.id && !submitData.current.id) {
            submitData.current = _.cloneDeep(productData);
            if (mode === PRODUCT_DIALOG_MODE.UPDATE || mode === PRODUCT_DIALOG_MODE.READ) {
                setMediaType(productData.mediaType);
            }
        }
    }, [productData, mode]);
    // Display API call results
    useEffect(() => {
        if (isSuccess === false) {
            // Display validation errors
            if (errors.code === APIErrors.badRequest && _.get(errors, 'message.message') === undefined && !errors?.messageError) {
                setError(errors.document && errors.document.message);
                setValidateResults(errors);
                return;
            }

            // Display general errors in dialog
            const message = _.isString(_.get(errors, 'message.message'))
                ? errors?.message?.message || errors?.messageError
                : intl.formatMessage({ id: 'apiErrors.default' });

            setDialog({
                isOpen: true,
                severity: 'error',
                message,
            });
        }
    }, [isSuccess, errors, intl]);

    // Cleanup Redux store and close dialog
    useEffect(() => {
        if (isSuccess !== undefined) {
            if (mode === PRODUCT_DIALOG_MODE.UPDATE) updateProductClear();
            else if (mode === PRODUCT_DIALOG_MODE.CREATE) createProductClear();
        }
    }, [isSuccess, createProductClear, updateProductClear, mode]);

    // Close dialog on submit successfully
    useEffect(() => {
        if (isSuccess) {
            setNameFile('');
            closeDialogFunction();
        }
    }, [isSuccess, closeDialogFunction]);

    // Reset form data when dialog closes
    useEffect(() => {
        if (!isOpenProductDialog) {
            submitData.current = {};
            setValidateResults({});
            setBusinessCardParams(defaultBusinessCardParams);
            setDisplayBusinessCard('0');
            setPrice('');
            setTotalProduct('');
        }
    }, [isOpenProductDialog]);

    //  ★★ setProductTLData、setProductDescriptionTLData関連はジャンボにて追加2023-7 by K.T.
    useEffect(() => {
        if (isOpenProductDialog && mode === PRODUCT_DIALOG_MODE.CREATE) {
            setContactExtraValue(BUSINESS_CONTACT.hide.extraValue);
            setOutsideLinkValue('false');

            /*  ★★　ダイアログオープン時、Createで新規登録時には、TLData関連のステータスを強制ブランクにする . PRODUCT_DIALOG_MODEが取れてないため直打ち */
            setProductTLData((prevState)=>({ ...prevState,pEN: null,}));
            setProductDescriptionTLData((prevState)=>({ ...prevState,pEN: null,}));

            console.log("L226");
        } else if (isOpenProductDialog && mode === PRODUCT_DIALOG_MODE.UPDATE) {
            setContactExtraValue('');
            setOutsideLinkValue('');
 /*            
            if( productData.productNameEN ) { 
                setProductTLData((prevState)=>({ ...prevState,pEN: productData.productNameEN,}));
                console.log("L233");
            }
            if( productData.productDescriptionEN ) { 
                setProductDescriptionTLData((prevState)=>({ ...prevState,pEN: productData.productDescriptionEN,}));
                console.log("L237");
            }
            console.log("L239");
*/

        } else if (! isOpenProductDialog ){
            setProductTLData({pJP:null,pEN:null});
            setProductDescriptionTLData({pJP:null,pEN:null});
        }
    }, [isOpenProductDialog, mode]);

    /*  ★★ page/.../ProductManagementのapplyReOrderProductListの UpdateProductOrderを受けた場合の特殊処理のuserEffectを追加。★★ */
    useEffect(() => {
        if (isOpenProductDialog && mode==PRODUCT_DIALOG_MODE.UPDATE && productData.productNameEN != "") {
            setProductTLData((prevState)=>({ ...prevState,pEN: productData.productNameEN,}));
            console.log("L251");
        }
    }, [isOpenProductDialog, productData.productNameEN, mode]);
    useEffect(() => {
        if (isOpenProductDialog && mode==PRODUCT_DIALOG_MODE.UPDATE && productData.productDescriptionEN != "") {
            setProductDescriptionTLData((prevState)=>({ ...prevState,pEN: productData.productDescriptionEN,}));
            console.log("L251");
        }
    }, [isOpenProductDialog,  productData.productDescriptionEN, mode]);



    useEffect(() => {
        if (!_.isUndefined(productData.businessContact)) {
            const contact = productData.businessContact ? BUSINESS_CONTACT.show.extraValue : BUSINESS_CONTACT.hide.extraValue;
            setContactExtraValue(contact);
        }
    }, [productData.businessContact, mode]);

    useEffect(() => {
        if (!_.isUndefined(productData.hasOutsideLink)) {
            setOutsideLinkValue(`${productData.hasOutsideLink}`);
        }
    }, [productData.hasOutsideLink, mode]);

    useEffect(() => {
        if (!_.isUndefined(productData.price)) {
            setPrice(productData.price);
        }
    }, [productData.price, mode]);

    useEffect(() => {
        if (!_.isUndefined(productData.productAvailableProduct)) {
            setTotalProduct(productData.productAvailableProduct);
        }
    }, [productData.productAvailableProduct, mode]);

    const handleChangeMediaType = (e) => setMediaType(parseInt(e.target.value, 10));

    const handleCloseErrorDialog = () => setDialog({ ...dialog, isOpen: false });

    const formatProductDataToSubmit = (params) => {
        const productInfo = {
            media_type: params.mediaType,
            media: params.media,
            name: params.productName,
            description: params.productDescription,
            purchase_link: params.purchaseLink,
            has_outside_link: ['true', true, '1', 1].includes(params.hasOutsideLink) ? '1' : '0',
            document: params.document,
            document_link: params.documentRequestReception,
            survey_link: params.survey,
            business_contact: params.businessContact ? '1' : '0',
            outside2_link: params.bulletin,
            outside3_link: params.externalLink3,
            business_card: displayBusinessCard,
            price: params.price ? params.price : 0,
            available: !_.isNumber(params.available) ? productData.productAvailableProduct : +params.available,
        };

        if (!_.isEmpty(eventInfo.languages)) {
            productInfo.name_en = params.productNameEN;
            productInfo.description_en = params.productDescriptionEN;
        }

        const formattedParams = {
            ...productInfo,
            ...businessCardParams,
        };

        const validJSONParams = CommonFunctions.trimObject(_.mapValues(formattedParams, (v) => (_.isNil(v) ? '' : v)));

        return validJSONParams;
    };

    const handleClickSave = () => {
        submitData.current = {
            ...submitData.current,
            ...businessCardParams,
        };
        const isValid = validate(submitData.current);
        if (userInfo.organizer_booth === BOOTH_TYPE.GRAND && price === '') {
            setCheckPrice(true);
        } else {
            setCheckPrice(false);
        }

        if (userInfo.organizer_booth === BOOTH_TYPE.GRAND && (totalProduct === '')) {
            setCheckTotalProduct(true);
        } else {
            setCheckTotalProduct(false);
        }

        if (isValid && !(price === '' && userInfo.organizer_booth === BOOTH_TYPE.GRAND)
        && !(userInfo.organizer_booth === BOOTH_TYPE.GRAND && (totalProduct === ''))) {
            if (submitData.current.media || productData.mediaType !== mediaType) submitData.current.mediaType = mediaType;
            else submitData.current.mediaType = undefined;

            if (mode === PRODUCT_DIALOG_MODE.UPDATE) updateProduct(companyID, productID, formatProductDataToSubmit(submitData.current));
            else if (mode === PRODUCT_DIALOG_MODE.CREATE) createProduct(companyID, formatProductDataToSubmit(submitData.current));
        }
    };
    const handleUpload = (event) => {
        event.preventDefault();
        const file = event.target.files[0];
        const sizeLimit = 15;
        if (file) {
            if ((file.size / (1024 * 1024)) > sizeLimit) {
                const sizeLimitDisplay = sizeLimit >= 1024 ? `${sizeLimit / 1024}GB` : `${sizeLimit}MB`;
                setError(intl.formatMessage({ id: 'validation.maxSize' }, { maxSize: sizeLimitDisplay }));
                return;
            }
            setNameFile(file.name);
            handleSetData('document', file);
            setError('');
            event.target.value = ''; // clear file
        }
    };
    const handleCloseProductDialogCreate = () => {
        setNameFile('');
        setPrice('');
        setError('');
        setTotalProduct('');
        setCheckTotalProduct(false);
        setCheckPrice(false);
        handleCloseProductDialog();
    };

    useEffect(() => {
        setNameFile(getFileNameFromUrl(productData.documentFileSource));
    }, [productData.documentFileSource]);

    const handleClickEdit = () => onClickChangeToEditDialog();

    const handleSetData = (field, value) => {
        submitData.current[field] = value;
    };

    const validate = (values) => {
        const {
            media, mediaFileSource, productName, productDescription, purchaseLink, businessContact,
            documentRequestReception, survey, externalLink, bulletin, externalLink3,
            department, position, first_name, last_name,
            zip_code, address, phone_number, fax_number, email_public, email_notifications,
            productNameEN, productDescriptionEN,
        } = values;

        const validateRules = {
            productImage: [() => !mediaFileSource && Validation.isNotEmpty(media)],
            productName: [
                () => Validation.isNotEmpty(productName),
                () => Validation.validateMaxLength(productName, SERVER_CHAR_LIMIT.TEXT_FIELD, typeof productName),
            ],
            productNameEN: [
                () => !_.isEmpty(eventInfo.languages) && Validation.isNotEmpty(productNameEN),
                () => !_.isEmpty(eventInfo.languages) && Validation.validateLatin(productNameEN),
                () => !_.isEmpty(eventInfo.languages) && Validation.validateMaxLength(productNameEN, SERVER_CHAR_LIMIT.TEXT_FIELD, typeof productNameEN),
            ],
            productDescription: [
                () => Validation.isNotEmpty(productDescription),
                () => Validation.validateMaxLength(productDescription, SERVER_CHAR_LIMIT.TEXT_FIELD, typeof productDescription),
            ],
            productDescriptionEN: [
                () => !_.isEmpty(eventInfo.languages) && Validation.isNotEmpty(productDescriptionEN),
                () => !_.isEmpty(eventInfo.languages) && Validation.validateLatin(productDescriptionEN),
                () => !_.isEmpty(eventInfo.languages) && Validation.validateMaxLength(productDescriptionEN, SERVER_CHAR_LIMIT.TEXT_FIELD, typeof productDescriptionEN),
            ],
            purchaseLink: [
                () => Validation.validateMaxLength(purchaseLink, SERVER_CHAR_LIMIT.TEXT_FIELD, typeof purchaseLink),
            ],
            businessContact: [
                () => Validation.validateMaxLength(businessContact, SERVER_CHAR_LIMIT.TEXT_FIELD, typeof businessContact),
            ],
            documentRequestReception: [
                () => Validation.validateMaxLength(documentRequestReception, SERVER_CHAR_LIMIT.TEXT_FIELD, typeof documentRequestReception),
            ],
            survey: [
                () => Validation.isValidUrl(survey),
                () => Validation.validateMaxLength(survey, SERVER_CHAR_LIMIT.TEXT_FIELD, typeof survey),
            ],
            externalLink: [
                () => Validation.validateMaxLength(externalLink, SERVER_CHAR_LIMIT.TEXT_FIELD, typeof externalLink),
            ],
            bulletin: [
                () => Validation.isValidUrl(bulletin),
                () => Validation.validateMaxLength(bulletin, SERVER_CHAR_LIMIT.TEXT_FIELD, typeof bulletin),
            ],
            externalLink3: [
                () => Validation.isValidUrl(externalLink3),
                () => Validation.validateMaxLength(externalLink3, SERVER_CHAR_LIMIT.TEXT_FIELD, typeof externalLink3),
            ],
        };

        const validateBusinessCard = {
            department: [
                () => Validation.validateMaxLength(department, MAX_CHAR_LENGTH, typeof department),
            ],
            position: [
                () => Validation.validateMaxLength(position, MAX_CHAR_LENGTH, typeof position),
            ],
            first_name: [
                () => Validation.isNotEmpty(first_name),
                () => Validation.validateMaxLength(first_name, MAX_CHAR_LENGTH, typeof first_name),
            ],
            last_name: [
                () => Validation.isNotEmpty(last_name),
                () => Validation.validateMaxLength(last_name, MAX_CHAR_LENGTH, typeof last_name),
            ],
            zip_code: [
                () => Validation.isNotEmpty(zip_code),
                () => Validation.validateMaxLength(zip_code, MAX_CHAR_LENGTH, typeof zip_code),
            ],
            address: [
                () => Validation.isNotEmpty(address),
                () => Validation.validateMaxLength(address, MAX_ADDRESS_CHAR_LENGTH, typeof address),
            ],
            phone_number: [
                () => Validation.isNotEmpty(phone_number),
                () => Validation.validatePhoneNumber(phone_number.trim()),
            ],
            fax_number: [
                () => Validation.validateMaxLength(fax_number, MAX_CHAR_LENGTH, typeof fax_number),
            ],
            email_public: [
                () => Validation.isNotEmpty(email_public),
                () => Validation.validateMaxLength(email_public, MAX_CHAR_LENGTH, typeof email_public),
                () => Validation.validateEmail(email_public),
            ],
            email_notifications: [
                () => Validation.isNotEmpty(email_notifications),
                () => Validation.validateMaxLength(email_notifications, MAX_CHAR_LENGTH, typeof email_notifications),
                () => Validation.validateEmail(email_notifications),
            ],
        };

        let validateResult;

        if (displayBusinessCard === '1') {
            validateResult = Validation.validateAllRules({ ...validateRules, ...validateBusinessCard });
        } else {
            validateResult = Validation.validateAllRules({ ...validateRules });
        }

        if (Object.keys(validateResult).length > 0) {
            setValidateResults({ ...validateResult });
            formRef.current.scrollIntoView({ behavior: 'smooth' });
            return false;
        }
        setValidateResults({});
        return true;
    };

    const getFileNameFromUrl = (value) => {
        if (!value) return '';
        const lastSlashIndex = value.lastIndexOf('/');
        if (lastSlashIndex === -1) return value;
        return value.slice(lastSlashIndex + 1);
    };

    const mediaTypeToUploadType = (value) => {
        switch (value) {
            case MEDIA_TYPE.VIDEO:
                return 'video';
            case MEDIA_TYPE.AUDIO:
                return 'audio';
            default:
                return 'image';
        }
    };

    const mediaTypeSizeLimit = (value) => {
        switch (value) {
            case MEDIA_TYPE.VIDEO:
            case MEDIA_TYPE.AUDIO:
                return 100;
            case MEDIA_TYPE.IMAGE:
                return 15;
            default:
                return undefined;
        }
    };

    const handleChangeBusinessContact = (event) => {
        const contactValue = event.target.value === BUSINESS_CONTACT.show.extraValue ? BUSINESS_CONTACT.show.mainValue : BUSINESS_CONTACT.hide.mainValue;
        setContactExtraValue(`${event.target.value}`);
        handleSetData('businessContact', contactValue);
    };

    const handleChangeOutsideLink = (e) => {
        setOutsideLinkValue(`${e.target.value}`);
        handleSetData('hasOutsideLink', e.target.value === 'true' ? '1' : '0');
    };

    const calculateLimitDurationByType = () => {
        if (mediaType === MEDIA_TYPE.VIDEO) {
            return eventInfo.max_vtime_exhibition;
        }

        if (mediaType === MEDIA_TYPE.AUDIO) {
            return eventInfo.max_atime_exhibition;
        }

        return 0;
    };

    const handleChangeDisplayBusinessCard = (e) => {
        setDisplayBusinessCard(e.target.value);
        handleSetData('business_card', e.target.value);
    };

    const handleChangePrice = (cost) => {
        if (/^\d*$/.test(cost)) {
            const value = cost || '';
            setPrice(value);
            handleSetData('price', value);
        }
    };

    const handleChangeTotal = (e) => {
        if (/^\d*$/.test(e.target.value)) {
            const value = e.target.value ? parseInt(e.target.value, 10) : '';
            setTotalProduct(value);
            handleSetData('available', value);
        }
    };

    const watchPriceChange = (e) => {
        if (!/^\d*$/.test(e.key)) e.preventDefault();
    };

    const renderProductInfoRow = (label, isRequired, content) => (
        <GridContainer className={classes.spacing}>
            <GridItem xs={12} sm={4} md={3}>
                <Typography bold required={mode === PRODUCT_DIALOG_MODE.READ ? false : isRequired}>
                    <FormattedMessage id={label} />
                </Typography>
            </GridItem>
            <GridItem xs={12} sm={8} md={9}>
                {content}
            </GridItem>
        </GridContainer>
    );

    const renderProductImage = () => {
        if (mode === PRODUCT_DIALOG_MODE.READ) {
            if (mediaType === MEDIA_TYPE.IMAGE) {
                return (
                    <img src={productData.mediaFileSource} alt="" style={{ maxWidth: '100%', maxHeight: '200px' }} />
                );
            }
            return (
                <ReactPlayer
                    url={productData.mediaFileSource && `${productData.mediaFileSource}?token=${token}`}
                    mediaType={mediaType}
                    status={productData.media_status}
                />
            );
        }
        return (
            <Box mt="-9px">
                <RadioGroup row value={mediaType} onChange={handleChangeMediaType}>
                    <FormControlLabel
                        classes={{ label: classes.radioButton }}
                        control={<Radio color="primary" />}
                        label={intl.formatMessage({ id: 'image' })}
                        value={MEDIA_TYPE.IMAGE}
                    />
                    <FormControlLabel
                        classes={{ label: classes.radioButton }}
                        control={<Radio color="primary" />}
                        label={intl.formatMessage({ id: 'video' })}
                        value={MEDIA_TYPE.VIDEO}
                    />
                    <FormControlLabel
                        classes={{ label: classes.radioButton }}
                        control={<Radio color="primary" />}
                        label={intl.formatMessage({ id: 'audio' })}
                        value={MEDIA_TYPE.AUDIO}
                    />
                </RadioGroup>
                <UploadButton
                    imagePreview={mediaType === MEDIA_TYPE.IMAGE && productData.mediaFileSource ? productData.mediaFileSource : undefined}
                    namePreview={mediaType !== MEDIA_TYPE.IMAGE && productData.mediaFileSource
                        ? productData.mediaFileSource.slice(productData.mediaFileSource.lastIndexOf('/') + 1)
                        : undefined}
                    type={mediaTypeToUploadType(mediaType)}
                    maxSize={mediaTypeSizeLimit(mediaType)}
                    onChange={(value) => handleSetData('media', value)}
                    limitDuration={calculateLimitDurationByType()}
                />
                {
                    !!validateResults.productImage && (
                        <Typography
                            color="danger"
                            variant="caption"
                            component="div"
                            classes={{ caption: classes.errorText }}
                        >
                            {intl.formatMessage({ id: validateResults.productImage.message })}
                        </Typography>
                    )
                }
            </Box>
        );
    };

    const renderActionButtons = () => (
        <Box style={{ margin: 'auto' }}>
            <Button
                autoFocus
                gradient
                size="md"
                color="success"
                className={classes.btn}
                style={{ width: '200px', fontSize: '20px', left: ' 20%' }}
                onClick={mode === PRODUCT_DIALOG_MODE.READ ? handleClickEdit : handleClickSave}
            >
                {intl.formatMessage({ id: mode === PRODUCT_DIALOG_MODE.READ ? 'edit' : 'save' })}
            </Button>
            <Button
                autoFocus
                gradient
                size="md"
                color="danger"
                style={{ width: '150px', marginRight: '10px', left: ' 80%' }}
                onClick={handleCloseProductDialogCreate}
            >
                {intl.formatMessage({ id: 'cancel' })}
            </Button>
        </Box>
    );
    
    /*★★　jmb K.T add 2023-7-8 for jp->en translation */
    /* このファイル内での状態管理で日英・自動翻訳の反映を行う */
    const [productTLData, setProductTLData ]=useState({
        pJP: '',
        pEN: '',
    });
    const [productDescriptionTLData, setProductDescriptionTLData ]=useState({
        pJP: '',
        pEN: '',
    });
    
    
    const handleProductNameJpEnTranslate= async (event)=>{
        const jN = event.target.value;
        setProductTLData((prevState)=>({
            ...prevState,
            pJP : jN,
        }));
        if( jN ===""){
            setProductTLData((prevState)=>({
                ...prevState,
                pEN : "",
            }));
            handleSetData('productNameEN', "");
        }else{
            try {
                const response = await API.get({
                            endpoint: '/workTranslateJpEn/',
                            body    :  { japanese_name : jN}
                } );
                const EnNm     = response.english_name;
                setProductTLData((prevState)=>({
                    ...prevState,
                    pEN : EnNm,
                }));
                handleSetData('productNameEN', EnNm);
            } catch (error){
                console.error('ERROR_jmbTranslate:',error);
            }
        }
    };
    const reproduce_ProductNameENbyYourHand=(val)=>{
        if(val===""){
            setProductTLData((prevState)=>({...prevState,pEN:"",}));
        }else{
            setProductTLData((prevState)=>({...prevState,pEN:val,}));
        }
    };


    const handleProductDescriptionJpEnTranslate= async (event)=>{
        const jN = event.target.value;
        setProductDescriptionTLData((prevState)=>({
            ...prevState,
            pJP : jN,
        }));
        if( jN ==""){
            setProductDescriptionTLData((prevState)=>({
                ...prevState,
                pEN : "",
            }));
            handleSetData('productDescriptionEN', "");
        }else{
            try {
                const response = await API.get({
                            endpoint: '/workTranslateJpEn/',
                            body    :  { japanese_name : jN}
                } );
                const EnNm     = response.english_name;
                setProductDescriptionTLData((prevState)=>({
                    ...prevState,
                    pEN : EnNm,
                }));
                handleSetData('productDescriptionEN', EnNm);
            } catch (error){
                console.error('ERROR_jmbTranslate_description:',error);
            }
        }
    };
    const reproduce_ProductDescriptionENbyYourHand=(val)=>{
        if(val===""){
            setProductDescriptionTLData((prevState)=>({...prevState,pEN:"",}));
        }else{
            setProductDescriptionTLData((prevState)=>({...prevState,pEN:val,}));
        }
    };



    return (
        <>
            <FormDialog
                isOpen={isOpenProductDialog}
                handleClose={handleCloseProductDialogCreate}
                title={dialogTitle}
                actions={renderActionButtons()}
            >
                <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" bgcolor={whiteColor}>
                    <Box width="100%" ref={formRef} className={classes.detailWrapper}>
                        {renderProductInfoRow(customText?.content?.field_name?.product_image || 'productRegister.productImage', true, renderProductImage())}
                        {renderProductInfoRow(!_.isEmpty(eventInfo.languages)
                            ? (
                                (!_.isEmpty(customText?.content?.field_name?.product_name) && `${customText?.content?.field_name?.product_name}（和文）`)
                                || 'productRegister.productNameJP')
                            : (customText?.content?.field_name?.product_name || 'productRegister.productName'),
                        true,
                        mode === PRODUCT_DIALOG_MODE.READ
                            ? productData.productName
                            : ( <>
                                <CleanableInput
                                    defaultValue={productData.productName}
                                    isMultiline
                                    onChange={(value) => {
                                            handleSetData('productName', value);
//                                            console.log("jp_product" + value);
                                        }      
                                    }
                                    onBlur={(event) => {
                                            handleProductNameJpEnTranslate(event);
                                            console.log("jp_product" + event.target.value);
                                        }      
                                    }
                                error={!!validateResults.productName}
                                    helperText={validateResults.productName
                                        ? intl.formatMessage({ id: validateResults.productName.message }, { maxLength: SERVER_CHAR_LIMIT.TEXT_FIELD }) : ''}
                                />
                                <Typography>
                                        {intl.formatMessage({ id: 'registerViewer.jpEnTranslateHelp' })}
                                </Typography>
                                </>
                            ))}
                        {!_.isEmpty(eventInfo.languages) && renderProductInfoRow((!_.isEmpty(customText?.content?.field_name?.product_name)
                            && `${customText?.content?.field_name?.product_name}（英文）`)
                            || 'productRegister.productNameEN',
                        true,
                        mode === PRODUCT_DIALOG_MODE.READ
                            ? productData.productNameEN
                            : (
                                <CleanableInput
                                   // defaultValue={productData.productNameEN}
                                    isMultiline
                                    onChange={(value) => {  reproduce_ProductNameENbyYourHand(value);
                                                            handleSetData('productNameEN', value);
                                                            console.log("En_product" + value);
                                                        }
                                             }
                                    value={productTLData.pEN}
                                    error={!!validateResults.productNameEN}
                                    helperText={validateResults.productNameEN
                                        ? intl.formatMessage({ id: validateResults.productNameEN.message }, { maxLength: SERVER_CHAR_LIMIT.TEXT_FIELD }) : ''}
                                />
                            ))}
                        {renderProductInfoRow(customText?.content?.field_name?.description
                        || (!_.isEmpty(eventInfo.languages)
                            ? ((!_.isEmpty(customText?.content?.field_name?.description)
                                && `${customText?.content?.field_name?.description}（和文）`)
                                || 'productRegister.productDescriptionJP')
                            : (customText?.content?.field_name?.description || 'productRegister.productDescription')),
                        true,
                        mode === PRODUCT_DIALOG_MODE.READ
                            ? productData.productDescription
                            : ( <>
                                <CleanableInput
                                    defaultValue={productData.productDescription}
                                    isMultiline
                                    rows={3}
                                    onChange={(value) => {
                                        handleSetData('productDescription', value);
//                                            console.log("jp_product" + value);
                                        }      
                                    }
                                    onBlur={(event) => {
                                        handleProductDescriptionJpEnTranslate(event);
                                        console.log("jp_productDescription" + event.target.value);
                                        }      
                                    }


                                    error={!!validateResults.productDescription}
                                    helperText={validateResults.productDescription
                                        ? intl.formatMessage({ id: validateResults.productDescription.message }, { maxLength: SERVER_CHAR_LIMIT.TEXT_FIELD }) : ''}
                                />
                                <Typography>
                                        {intl.formatMessage({ id: 'registerViewer.jpEnTranslateHelp' })}
                                </Typography>
                                </>
                            ))}
                        {!_.isEmpty(eventInfo.languages) && renderProductInfoRow((!_.isEmpty(customText?.content?.field_name?.description)
                            && `${customText?.content?.field_name?.description}（英文）`)
                            || 'productRegister.productDescriptionEN',
                        true,
                        mode === PRODUCT_DIALOG_MODE.READ
                            ? productData.productDescriptionEN
                            : ( <>
                                <CleanableInput
                                   // defaultValue={productData.productDescriptionEN}
                                    isMultiline
                                    rows={3}
                                    onChange={(value) =>{
                                            reproduce_ProductDescriptionENbyYourHand(value);
                                            handleSetData('productDescriptionEN', value);
                                             } }
                                    value={productDescriptionTLData.pEN}
                                    error={!!validateResults.productDescriptionEN}
                                    helperText={validateResults.productDescriptionEN
                                        ? intl.formatMessage({ id: validateResults.productDescriptionEN.message }, { maxLength: SERVER_CHAR_LIMIT.TEXT_FIELD }) : ''}
                                />
                                <Typography>５００文字以内（スペース、改行、記号も含みます）</Typography>
                                </>

                            ))}
                        {userInfo.organizer_booth === BOOTH_TYPE.GRAND && renderProductInfoRow(customText?.content?.field_name?.total_quantity || 'productRegister.productAvailableProduct', true,
                            mode === PRODUCT_DIALOG_MODE.READ
                                ? +productData.productAvailableProduct
                                : (
                                    <TextField
                                        variant="outlined"
                                        className={classes.currencyInput}
                                        value={totalProduct}
                                        onChange={(value) => handleChangeTotal(value)}
                                        onKeyPress={watchPriceChange}
                                        inputProps={{
                                            min: 0,
                                        }}
                                        InputProps={{ classes: { root: `${classes.numberInput}` } }}
                                        error={!!checkTotalProduct}
                                        helperText={checkTotalProduct
                                            ? '必須です。入力してください。' : ''}
                                    />
                                ))}
                        {settingsDisplayInfo.display_purchase_link && renderProductInfoRow(customText?.content?.field_name?.product_purchase || 'productRegister.purchaseLink', false,
                            mode === PRODUCT_DIALOG_MODE.READ
                                ? productData.purchaseLink
                                : (
                                    <CleanableInput
                                        defaultValue={productData.purchaseLink}
                                        onChange={(value) => handleSetData('purchaseLink', value)}
                                        error={!!validateResults.purchaseLink}
                                        helperText={validateResults.purchaseLink
                                            ? intl.formatMessage({ id: validateResults.purchaseLink.message }, { maxLength: SERVER_CHAR_LIMIT.TEXT_FIELD }) : ''}
                                    />
                                ))}

                        {userInfo.organizer_booth === BOOTH_TYPE.GRAND && renderProductInfoRow(customText?.content?.field_name?.price || 'price', true,
                            mode === PRODUCT_DIALOG_MODE.READ
                                ? `${intl.formatNumber(price)}円`
                                : (
                                    <InputHasUnit
                                        defaultValue={price}
                                        className={classes.numberInput}
                                        onChange={(value) => handleChangePrice(value)}
                                        onKeyPress={watchPriceChange}
                                        unit="円"
                                        minValue={0}
                                        error={!!checkPrice}
                                        helperText={checkPrice
                                            ? '必須です。入力してください。' : ''}
                                    />
                                ))}

                        {settingsDisplayInfo.display_has_outside_link && renderProductInfoRow(customText?.content?.field_name?.direct_consultation || 'productRegister.externalLink', false,
                            mode === PRODUCT_DIALOG_MODE.READ
                                ? OUTSIDE_LINK[productData.hasOutsideLink]
                                : (
                                    <>
                                        <RadioGroup
                                            row
                                            value={outsideLinkValue}
                                            onChange={handleChangeOutsideLink}
                                        >
                                            <FormControlLabel
                                                classes={{ label: classes.radioButton }}
                                                control={<Radio color="primary" />}
                                                label="利用する"
                                                value="true"
                                            />
                                            <FormControlLabel
                                                classes={{ label: classes.radioButton }}
                                                control={<Radio color="primary" />}
                                                label="利用しない"
                                                value="false"
                                            />
                                        </RadioGroup>
                                        {
                                            !!validateResults.has_outside_link && (
                                                <Typography
                                                    color="danger"
                                                    variant="caption"
                                                    component="div"
                                                    classes={{ caption: classes.errorText }}
                                                >
                                                    {intl.formatMessage({ id: validateResults.has_outside_link.message })}
                                                </Typography>
                                            )
                                        }
                                    </>
                                ))}

                        {settingsDisplayInfo.display_document && renderProductInfoRow(customText?.content?.field_name?.material_upload || 'productRegister.productDocumentation', false,
                            mode === PRODUCT_DIALOG_MODE.READ
                                ? (
                                    <a href={productData.documentFileSource} target="blank">
                                        {getFileNameFromUrl(productData.documentFileSource)}
                                    </a>
                                )
                                : (
                                    <>
                                        <Button size="md" component="label" color="info">
                                            <input
                                                type="file"
                                                style={{ display: 'none' }}
                                                onChange={handleUpload}
                                            />
                                            <UploadIcon />
                                        </Button>
                                        {
                                            error && (
                                                <Typography color="danger" style={{ marginTop: '8px' }}>
                                                    {error}
                                                </Typography>
                                            )

                                        }
                                        {nameFile && (
                                            <div style={{ margin: '8px' }}>
                                                <Typography color="info">
                                                    {nameFile}
                                                </Typography>
                                            </div>
                                        )}
                                    </>
                                ))}
                        {settingsDisplayInfo.display_document_link && renderProductInfoRow(customText?.content?.field_name?.document_request || 'productRegister.documentRequestReception', false,
                            mode === PRODUCT_DIALOG_MODE.READ
                                ? productData.documentRequestReception
                                : (
                                    <>
                                        <CleanableInput
                                            defaultValue={productData.documentRequestReception}
                                            onChange={(value) => handleSetData('documentRequestReception', value)}
                                            error={!!validateResults.documentRequestReception}
                                            helperText={validateResults.documentRequestReception
                                                ? intl.formatMessage({ id: validateResults.documentRequestReception.message }, { maxLength: SERVER_CHAR_LIMIT.TEXT_FIELD }) : ''}
                                        />
                                        <Typography>
                                            ＊御社の資料請求申し込みＵＲＬを入力してください。
                                        </Typography>
                                    </>
                                ))}
                        {settingsDisplayInfo.display_survey_link && renderProductInfoRow(customText?.content?.field_name?.questionnaire || 'productRegister.survey', false,
                            mode === PRODUCT_DIALOG_MODE.READ
                                ? productData.survey
                                : (
                                    <CleanableInput
                                        defaultValue={productData.survey}
                                        onChange={(value) => handleSetData('survey', value)}
                                        error={!!validateResults.survey}
                                        helperText={validateResults.survey
                                            ? intl.formatMessage({ id: validateResults.survey.message }, { maxLength: SERVER_CHAR_LIMIT.TEXT_FIELD }) : ''}
                                    />
                                ))}
                        {settingsDisplayInfo.display_business_contact
                        && renderProductInfoRow(customText?.content?.field_name?.business_negotiations_inquiries || 'productRegister.businessContactNewText', false,
                            mode === PRODUCT_DIALOG_MODE.READ
                                ? BUSINESS_CONTACT_VIEW[productData.businessContact]
                                : (
                                    <RadioGroup
                                        row
                                        value={contactExtraValue}
                                        onChange={handleChangeBusinessContact}
                                    >
                                        <FormControlLabel
                                            classes={{ label: classes.radioButton }}
                                            control={<Radio color="primary" />}
                                            label={BUSINESS_CONTACT.show.text}
                                            value={BUSINESS_CONTACT.show.extraValue}
                                        />
                                        <FormControlLabel
                                            classes={{ label: classes.radioButton }}
                                            control={<Radio color="primary" />}
                                            label={BUSINESS_CONTACT.hide.text}
                                            value={BUSINESS_CONTACT.hide.extraValue}
                                        />
                                    </RadioGroup>
                                ))}
                        {settingsDisplayInfo.display_outside2_link && renderProductInfoRow(customText?.content?.field_name?.board_room || 'productRegister.externalLink2', false,
                            mode === PRODUCT_DIALOG_MODE.READ
                                ? productData.bulletin
                                : (
                                    <CleanableInput
                                        defaultValue={productData.bulletin}
                                        onChange={(value) => handleSetData('bulletin', value)}
                                        error={!!validateResults.bulletin}
                                        helperText={validateResults.bulletin
                                            ? intl.formatMessage({ id: validateResults.bulletin.message }, { maxLength: SERVER_CHAR_LIMIT.TEXT_FIELD }) : ''}
                                    />
                                ))}
                        {settingsDisplayInfo.display_outside3_link && renderProductInfoRow(customText?.content?.field_name?.external_link || 'productRegister.externalLink3', false,
                            mode === PRODUCT_DIALOG_MODE.READ
                                ? productData.externalLink3
                                : (
                                    <>
                                        <CleanableInput
                                            defaultValue={productData.externalLink3}
                                            onChange={(value) => handleSetData('externalLink3', value)}
                                            error={!!validateResults.externalLink3}
                                            helperText={validateResults.externalLink3
                                                ? intl.formatMessage({ id: validateResults.externalLink3.message }, { maxLength: SERVER_CHAR_LIMIT.TEXT_FIELD }) : ''}
                                        />
                                        <Typography>
                                            ＊正しいＵＲＬを入力してください。
                                        </Typography>
                                    </>
                                ))}
                        {settingsDisplayInfo.display_business_card && renderProductInfoRow(customText?.content?.field_name?.business_card_exchange || 'productRegister.businessCard', false,
                            mode === PRODUCT_DIALOG_MODE.READ
                                ? DISPLAY_BUSINESS_CARD[productData.businessCard]
                                : (
                                    <RadioGroup
                                        row
                                        value={displayBusinessCard}
                                        onChange={handleChangeDisplayBusinessCard}
                                    >
                                        <FormControlLabel
                                            classes={{ label: classes.radioButton }}
                                            control={<Radio color="primary" />}
                                            label="利用する"
                                            value="1"
                                        />
                                        <FormControlLabel
                                            classes={{ label: classes.radioButton }}
                                            control={<Radio color="primary" />}
                                            label="利用しない"
                                            value="0"
                                        />
                                    </RadioGroup>
                                ))}

                        {/* Business card form fields */}

                        {(settingsDisplayInfo.display_business_card && displayBusinessCard === '1') && (
                            <BusinessCard
                                params={businessCardParams}
                                handleSetBusinessCardParams={handleSetBusinessCardParams}
                                validateResults={validateResults}
                                MAX_CHAR_LENGTH={MAX_CHAR_LENGTH}
                                mode={mode}
                                isOrganizer
                                customTextPersonInfo={customText?.content_company}
                            />
                        )}

                    </Box>
                </Box>
            </FormDialog>
            <Snackbar
                open={dialog.isOpen}
                onClose={handleCloseErrorDialog}
                message={dialog.message}
                severity={dialog.severity}
            />
            <ProgessDialog isOpen={loadingCreate} percent={progessCreate} />
            <Loader isLoading={isLoading} />
        </>
    );
};

ProductRegister.defaultProps = {
    closeDialogFunction: () => { },
    companyID: '',
    errorCreate: {},
    errorUpdate: {},
    onClickChangeToEditDialog: () => { },
    productData: {},
    productID: 0,
    successCreate: undefined,
    successUpdate: undefined,
    progessCreate: 0,
    loadingCreate: false,
    token: '',
    eventInfo: {},
    settingsDisplayInfo: {},
};

ProductRegister.propTypes = {
    companyID: PropTypes.string,
    closeDialogFunction: PropTypes.func,
    createProduct: PropTypes.func.isRequired,
    createProductClear: PropTypes.func.isRequired,
    dialogTitle: PropTypes.string.isRequired,
    errorCreate: PropTypes.objectOf(PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
    ])),
    errorUpdate: PropTypes.objectOf(PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
    ])),
    getProduct: PropTypes.func.isRequired,
    getProductClear: PropTypes.func.isRequired,
    handleCloseProductDialog: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    isOpenProductDialog: PropTypes.bool.isRequired,
    loadingCreate: PropTypes.bool,
    mode: PropTypes.oneOf([
        PRODUCT_DIALOG_MODE.CREATE,
        PRODUCT_DIALOG_MODE.READ,
        PRODUCT_DIALOG_MODE.UPDATE,
    ]).isRequired,
    onClickChangeToEditDialog: PropTypes.func,
    productData: PropTypes.objectOf(PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
        PropTypes.object,
    ])),
    productID: PropTypes.number,
    progessCreate: PropTypes.number,
    successCreate: PropTypes.bool,
    successUpdate: PropTypes.bool,
    token: PropTypes.string,
    updateProduct: PropTypes.func.isRequired,
    updateProductClear: PropTypes.func.isRequired,
    eventInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
    settingsDisplayInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
    userInfo: PropTypes.oneOfType([() => null, PropTypes.object]).isRequired,
};

export default ProductRegister;
